module.exports = __webpack_public_path__ + "img/process3.81858983.png";